import useTrans from '../../../../hooks/ui/useTrans';
import ErrorList from '../../../../types/UI/ErrorList';
import Button from '../../../Button/Button';
import Paragraph from '../../../Paragraph/Paragraph';
import Row from '../../../Row/Row';
import Stack from '../../../Stack/Stack';
import Title from '../../../Title/Title';

type CouponInvalidDialogProps = {
    errors: ErrorList;
    onBack: () => void;
    trans: ReturnType<typeof useTrans>;
};

const CouponInvalidDialog = ({
    errors,
    onBack,
    trans,
}: CouponInvalidDialogProps) => {
    return (
        <Stack space="large">
            <Title variant="area" align="center">
                {trans('CouponInvalidDialog.Title')}
            </Title>

            <Stack space="xsmall">
                <Paragraph align="center" bold>
                    {trans('CouponInvalidDialog.Intro')}
                </Paragraph>

                <Paragraph align="center">{errors}</Paragraph>
            </Stack>

            <Row vertical="middle" horizontal="center">
                <Button onClick={onBack}>
                    {trans('CouponInvalidDialog.BackButton')}
                </Button>
            </Row>
        </Stack>
    );
};

export default CouponInvalidDialog;
